import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../auth/role.guard';
import { MasterComponent } from './master/master.component';
import { NotfoundComponent } from './notfound/notfound.component';

const routes: Routes = [
  {
    path: '',
    component: MasterComponent,
    canActivateChild: [RoleGuard],
    children: [
      { path: 'crm', loadChildren: '../crm/crm.module#CrmModule', canActivateChild: [RoleGuard] },
      { path: 'cpi', loadChildren: '../cpi/cpi.module#CpiModule', canActivateChild: [RoleGuard] },
      { path: 'cms', loadChildren: '../cms/cms.module#CmsModule', canActivateChild: [RoleGuard] },
      { path: 'analytics', loadChildren: '../analytics/analytics.module#AnalyticsModule', canActivateChild: [RoleGuard] },
      { path: 'suite', loadChildren: () => import('../suite/suite.module').then(m => m.SuiteModule) },
      { path: 'mw', loadChildren: () => import('../mw/mw.module').then(m => m.MwModule) },
      { path: 'atlas/cms', redirectTo: 'cms', pathMatch: 'full' },
      { path: '', redirectTo: 'cms', pathMatch: 'full' },
      { path: '**', component: NotfoundComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule { }
